import { createSlice } from '@reduxjs/toolkit';

// Operator insights state (ingestion health, uptime report, margin report), mirroring
// store/tasks/tasksSlice.js: one loading/error surface, mutations only from thunk successes.
const initialState = {
  ingestionHealth: null,
  uptime: [],
  uptimePeriod: null,
  margin: [],
  autoTopUp: null,
  isLoading: false,
  error: null
};

const insightsSlice = createSlice({
  name: 'insights',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchIngestionHealthSuccess: (state, action) => {
      state.ingestionHealth = action.payload;
      state.isLoading = false;
    },
    fetchUptimeSuccess: (state, action) => {
      state.uptime = action.payload.devices;
      state.uptimePeriod = action.payload.period;
      state.isLoading = false;
    },
    fetchMarginSuccess: (state, action) => {
      state.margin = action.payload;
      state.isLoading = false;
    },
    fetchAutoTopUpSummarySuccess: (state, action) => {
      state.autoTopUp = action.payload;
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchIngestionHealthSuccess,
  fetchUptimeSuccess,
  fetchMarginSuccess,
  fetchAutoTopUpSummarySuccess
} = insightsSlice.actions;

export default insightsSlice.reducer;
